import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

const TranslatableImage = ({ name, iconSrc }) => {
    const titleRef = useRef(null);
    const imageRef = useRef(null);

    useEffect(() => {
        // Update de title wanneer de vertaling verandert
        const updateTitle = () => {
            if (titleRef.current && imageRef.current) {
                imageRef.current.title = titleRef.current.textContent;
            }
        };

        // Observeer veranderingen in de tekst (voor als Google Translate de tekst vertaalt)
        const observer = new MutationObserver(updateTitle);
        if (titleRef.current) {
            observer.observe(titleRef.current, {
                characterData: true,
                subtree: true,
                childList: true
            });
        }

        // Initial update
        updateTitle();

        return () => observer.disconnect();
    }, [name]);

    return (
        <>
            <img
                ref={imageRef}
                src={iconSrc}
                alt={name}
                className="w-6 h-6"
                onClick={() => alert(titleRef.current?.textContent || name)}
            />
            {/* Verborgen element dat vertaald zal worden */}
            <span
                ref={titleRef}
                style={{ display: 'none' }}
            >
                {name}
            </span>
        </>
    );
};

TranslatableImage.propTypes = {
    name: PropTypes.string.isRequired,
    iconSrc: PropTypes.string.isRequired
};

export default TranslatableImage;